import { render, staticRenderFns } from "./WidgetPointsHistory.vue?vue&type=template&id=128cb3fb&scoped=true"
import script from "./WidgetPointsHistory.vue?vue&type=script&lang=js"
export * from "./WidgetPointsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128cb3fb",
  null
  
)

export default component.exports